<template>
  <v-container id="regular-tables" fluid tag="section">
    <base-material-card
      icon="mdi-ballot"
      :title="type == 1 ? $i18n.t('Consignor') : $i18n.t('Consignee')"
      class="px-5 py-3 small-icon"
    >
      <z-grid-record :grid="grid" />

      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Name</th>
              <th class="text-left">Phone</th>
              <th class="text-left">Email</th>
              <th class="text-left">GST</th>
              <th class="text-left">City</th>
              <th class="text-right" width="100px;">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="consignor in grid.rows" :key="consignor._id">
              <td>{{ consignor.name }}</td>
              <td>{{ consignor.countryCode }} {{ consignor.phone }}</td>
              <td>{{ consignor.email }}</td>
              <td>{{ consignor.gstin }}</td>
              <td>{{ consignor.address ? consignor.address.city : "" }}</td>
              <td>
                <z-confirm-button
                  color="red"
                  class="float-right"
                  x-small
                  text
                  :loading="loading"
                  :message="
                    $i18n.t('Do you want to delete selected consignor ?')
                  "
                  @click="deleteConsignor(consignor._id)"
                >
                  <v-icon>mdi-trash-can-outline</v-icon>
                </z-confirm-button>
                <v-btn
                  class="float-right"
                  @click="editConsignor(consignor._id)"
                  fab
                  x-small
                  text
                  ><v-icon>mdi-pencil</v-icon></v-btn
                >
              </td>
            </tr>
            <!-- <consignor-row
              v-for="item in grid.rows"
              :key="item._id"
              :value="item"
              @editConsignor="editConsignor"
            >
            </consignor-row> -->
          </tbody>
        </template>
      </v-simple-table>

      <v-pagination
        v-model="grid.page"
        class="my-4"
        :length="grid.total"
        total-visible="10"
        @input="showPage"
      ></v-pagination>
    </base-material-card>
  </v-container>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "Consignor",
  props: {
    singlePage: {
      default: false,
    },
    showClose: {
      default: false,
    },
    type: {
      default: null,
    },
  },
})
export default class Consignor extends Vue {
  grid = { page: 0, rows: [] };
  on = null;
  page = 1;
  filterUrl = "";
  rows = 50;
  url = "/api/consignor/grid?_search=true&";
  dialog = true;
  path = "";
  leftColStyles = {};

  get loading() {
    return common.loading;
  }

  get gridHeight() {
    return this.windowHeight > 500 ? this.windowHeight - 150 : 300;
  }

  get itemHeight() {
    return this.windowWidth > 960 ? 75 : 240;
  }

  async mounted() {
    this.showPage(1);
  }

  async editConsignor(c_id) {
    this.$emit("editConsignor", c_id);
  }

  async showPage(page) {
    common.setLoading(true);
    this.page = page;
    try {
      debugger;
      let url = this.url + "&type=2";
      if (this.type == 1) {
        url = this.url + "&type=1";
      }
      const grid = await doGet(
        url + "&rows=" + this.rows + "&page=" + page + this.filterUrl
      );
      if (grid.rows && grid.rows.length > 0) {
        this.grid = grid;
      }
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }
  async deleteConsignor(consignor_id) {
    common.setLoading(true);
    try {
      await doGet("/api/consignor/" + consignor_id + "/delete");
      common.showMessage("Deleted Successfully");
      await this.showPage(this.page ? this.page : 1);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }
}
</script>

<style scoped>
.iframeWrapper {
  border: 1px solid #dfdfdf;
  width: 100%;
  overflow: auto;
  min-height: 650px;
}
</style>
